import React, { Dispatch, SetStateAction } from 'react';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';

interface TaskItemFooterProps {
  setShowTotalList: Dispatch<SetStateAction<boolean>>;
  showTotalList: boolean;
}

export const TaskItemFooter: React.FC<TaskItemFooterProps> = ({
  setShowTotalList,
  showTotalList,
}) => {
  return (
    <Box width="100%" p="8" display="flex" justifyContent="center" alignItems="center">
      <Button onClick={() => setShowTotalList(!showTotalList)} variant="subtleActive" size="small">
        {showTotalList ? 'Hide full list' : 'Show full list'}
      </Button>
    </Box>
  );
};
